import styled from 'styled-components';

export const StyledIndicator = styled.div`
  display: block;
  width: 20px;
  height: 20px;
  object-fit: contain;
  align-self: flex-end;
  justify-self: flex-end;
`;